var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.listLoading,
          expression: "listLoading",
        },
      ],
      staticClass: "red-packet-table-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "序号" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入序号" },
                    model: {
                      value: _vm.searchForm.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "id", $$v)
                      },
                      expression: "searchForm.id",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    attrs: { size: "small", placeholder: "请输入活动名称" },
                    model: {
                      value: _vm.searchForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "title", $$v)
                      },
                      expression: "searchForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("重置")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("创建红包活动")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, stripe: "", border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              width: "100",
              prop: "idd",
              align: "center",
              fixed: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动名称",
              width: "200",
              prop: "title",
              align: "center",
              fixed: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "副标题",
              width: "200",
              prop: "subtitle",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动图",
              width: "100",
              prop: "activityImage",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-image", {
                      staticStyle: { width: "60px" },
                      attrs: {
                        src: _vm.imageAccessDomain + scope.row.activityImage,
                        alt: "活动图",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "邀请类型",
              width: "100",
              prop: "inviteTypeName",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "满足邀请人数",
              prop: "inviteCount",
              width: "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "库存数",
              prop: "availableStock",
              width: "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "已领取数(发起)",
              prop: "initiatorUsedStock",
              width: "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "已领取数(助力)",
              prop: "helperUsedStock",
              width: "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "拉新人数",
              prop: "newUserCount",
              width: "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "激活人数",
              prop: "activeUserCount",
              width: "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动时间",
              prop: "activityTimeFormatter",
              width: "180",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.startTimeFormatter) +
                        "\n        "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.endTimeFormatter) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动创建时间",
              prop: "createTimeFormatter",
              width: "180",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "启用开关",
              prop: "enabled",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.enabled
                      ? _c(
                          "el-tag",
                          { attrs: { type: "primary", size: "small" } },
                          [_vm._v("启用")]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "info", size: "small" } },
                          [_vm._v("禁用")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "380",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleCopyToCreate(scope.row)
                          },
                        },
                      },
                      [_vm._v("复制")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleQrCode(scope.row)
                          },
                        },
                      },
                      [_vm._v("二维码")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleActivityDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("活动明细")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes,prev, pager, next,jumper",
              "page-size": _vm.searchForm.limit,
              "page-sizes": [10, 20, 30, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.qrDialogVisible,
            width: "560px",
            "before-close": function () {
              return (_vm.qrDialogVisible = false)
            },
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "10px 0" } },
            [
              _vm.qrImage
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "18px",
                        "font-size": "24px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v(_vm._s(_vm.qrObj.activityName) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.qrImage
                ? _c("el-image", {
                    staticStyle: {
                      "max-width": "320px",
                      "max-height": "320px",
                    },
                    attrs: { src: _vm.qrImage, fit: "contain" },
                  })
                : _c("div", [_vm._v("暂无二维码图片")]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }